import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AssessmentProgress } from '../graphs/assessmentprogress';
import { School } from '../dropdown-school/org.school';
import { OrgService } from '../_services/org.service';
import { ReportService } from '../_services/report-service';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { LoaderService } from '../loader/loader.service';
//Used to be called baseline assessments, but has been altered to show students who have been assessed at all before today.
@Component({
	selector: 'app-assessments-bar',
	templateUrl: './assessments-bar.component.html',
	styleUrls: ['./assessments-bar.component.css'],
})
export class AssessmentsBarComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedSchool: School;
	graphData: AssessmentProgress;
	title: string;

	constructor(
		private orgService: OrgService,
		private reportService: ReportService,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: School) => {
				//any school data change will get graph data.
				this.selectedSchool = data;
				if (this.selectedSchool) {
					this.getGraphDataSchool();
				}
			}),
		);

		this.subscriptions.push(
			this.reportService.assessmentProgress.subscribe(
				(graphData: AssessmentProgress) => {
					//any graph data change will cause a redraw.
					this.graphData = graphData;
					this.drawAssessmentProgress();
				},
			),
		);
	}

	private getGraphDataSchool() {
		//Previously this called "getProgAtBaseline" to graph the count of students who have been assessed before the Baseline date.
		//Now we call getProgAssessed to do the same thing but for any student assessed before today, essentially total assessed at all.
		this.reportService.getProgAssessed(this.selectedSchool.id).subscribe(
			(data) => {
				//init graph data from db.
				this.reportService.setAssessmentProgress(data);
			},
			(error) => {
				console.log(error);
			},
		);
	}

	drawAssessmentProgress() {
		//Previously drawAtBaselineProgress()
		let theData = [];
		theData.push(this.graphData.progressDataSchool[0].data.xBarName);
		for (let eachNum of this.graphData.progressDataSchool[0].data
			.columnData[0]) {
			theData.push(eachNum);
		}
		let theRemainder = [];
		theRemainder.push(this.graphData.progressDataSchool[0].data.xBarName2);
		for (let eachNum of this.graphData.progressDataSchool[0].data
			.columnData[1]) {
			theRemainder.push(eachNum);
		}
		let categories = this.graphData.progressDataSchool[0].data.yCategories;
		let xTicks = [];
		for (let i = 1; i <= this.graphData.progressDataSchool[0].data.xMax; i++) {
			xTicks.push(i);
		}
		let colorPattern = [];
		let assessedColor = ['#1492B7'];
		let notAssessedColor = ['#ffffff'];
		colorPattern[0] = assessedColor;
		colorPattern[1] = notAssessedColor;
		this.title = this.graphData.progressDataSchool[0].graphTitle;
		var chart = c3.generate({
			bindto: '#assessed-graph',
			data: {
				columns: [theData, theRemainder],
				type: 'bar',
				groups: [['Assessed', 'Not Assessed']],
				order: null,
			},
			legend: {
				hide: true,
			},
			color: {
				pattern: colorPattern,
			},
			axis: {
				rotated: true,
				y: {
					label: {
						text: this.graphData.progressDataSchool[0].data.xLabel,
						position: 'outer-center',
					},
					tick: {
						values: xTicks,
					},
				},
				x: {
					type: 'category',
					categories: categories,
				},
			},
			onresized: function () {
				setTimeout(drawLabels, 200);
			},
			transition: {
				duration: 100,
			},
		});
		let allLabels = [];
		for (let i = 1; i < theData.length; i++) {
			var thisLabel = {};
			allLabels.push(thisLabel);
		}
		var drawLabels = function () {
			//on resize
			for (let i = 1; i < theData.length; i++) {
				allLabels[i].attr(
					'transform',
					'translate(' +
						(chart.internal.y(theData[i]) +
							' , ' +
							chart.internal.x(i - 1) +
							')'),
				);
			}
		};
		for (let i = 1; i < theData.length; i++) {
			//define at first entry
			let percVal = Number(
				((theData[i] / (theData[i] + theRemainder[i])) * 100).toFixed(2),
			);
			let thisLabelText = percVal ? percVal : 0;
			allLabels[i] = d3
				.select('#assessed-graph svg g')
				.append('text')
				.text(thisLabelText + '%')
				.style('fill', '#000000')
				.attr(
					'transform',
					'translate(' +
						(chart.internal.y(theData[i] + 0.05) +
							' , ' +
							chart.internal.x(i - 0.94) +
							')'),
				)
				.style('text-anchor', 'start')
				.style('font-size', '0.85rem');
		}
	}

	ngAfterViewInit() {}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
